import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { AboutPage } from './pages/AboutPage';
import { LoanApplicationPage } from './pages/LoanApplicationPage';
import { DataCompliancePage } from './pages/DataCompliancePage';
import { CareersPage } from './pages/CareersPage';
import { TermsPage } from './pages/TermsPage';
import { PrivacyPage } from './pages/PrivacyPage';
export function AppRouter() {
  return <BrowserRouter data-id="element-2">
      <Routes data-id="element-3">
        <Route path="/" element={<Home data-id="element-5" />} data-id="element-4" />
        <Route path="/about" element={<AboutPage data-id="element-7" />} data-id="element-6" />
        <Route path="/apply" element={<LoanApplicationPage data-id="element-9" />} data-id="element-8" />
        <Route path="/legal/compliance" element={<DataCompliancePage data-id="element-11" />} data-id="element-10" />
        <Route path="/legal/terms" element={<TermsPage data-id="element-13" />} data-id="element-12" />
        <Route path="/legal/privacy" element={<PrivacyPage data-id="element-15" />} data-id="element-14" />
        <Route path="/careers" element={<CareersPage data-id="element-17" />} data-id="element-16" />
      </Routes>
    </BrowserRouter>;
}